import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export const PrivateRoute = ({ children, adminOnly = false }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ivory-50">
        <div className="animate-pulse text-ink-500 text-sm">Lade …</div>
      </div>
    );
  }
  if (user === null) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/gold" replace />;
  }
  if (!adminOnly && user.status !== "approved" && user.role !== "admin") {
    return <Navigate to="/pending" replace />;
  }
  return children;
};
